<template>
  <div>
    <button
      class="btn"
      @click="handleButtonPress(action)"
      v-text="action.title"
      :style="`background: ${background};`"
    />
  </div>
</template>

<script>
  export default {
    name: 'tile-action',
    props: {
      action: {
        required: true,
        type: Object
      },
      background: {
        required: false,
        type: String,
      }
    },
    methods: {
      async handleButtonPress (action) {
        // Matomo track the page + button press
        if (this.$matomo) {
          let url = window.location.href.split('/')[window.location.href.split('/').length - 1]
          let btnText = action.title
          btnText = btnText.toLowerCase()
          btnText = btnText.replace(/[`~!@#$%^&*()|+=?;:'",<>{}[\]\\/]/gi, '')
          btnText = btnText.replace(/\s/g, '')
          this.$matomo.trackEvent('CTA Buttons', `${url}_${btnText}`, `${url}_${btnText}`)
        }

        if (action.function) {
          return this.$root.handleTileAction(action)
        }

        if (action.tel || action.external) {
          return document.location.href = action.link
        }

        if (action.link) {
          this.$router.push(action.link)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  a {
    text-decoration: none;
  }
</style>